import { composeInitialState } from '@opengov/compose-app';
import { composeStateMachine } from '../module';
import { IFetchClaimsSuccess, RequestStatus } from './types';
import { Claims } from './records';

export const initialState = composeInitialState({
  claimApiStatus: RequestStatus(),
  claims: Claims(),
  // The entity the cached claims were granted for. Claims are entity-scoped, so this is
  // what makes a cached success reusable only within the same entity.
  claimsEntityUuid: null as string | null
});

export const claimsState = composeStateMachine('claims', initialState, compose => ({
  fetchClaims: compose.payloadlessAction(state => state.set('claimApiStatus', RequestStatus({ status: 'pending' }))),

  fetchClaimsSuccess: compose.action((state, { claims, entityUuid }: IFetchClaimsSuccess) =>
    state
      .set('claims', Claims(claims))
      .set('claimsEntityUuid', entityUuid)
      .set('claimApiStatus', RequestStatus({ status: 'success' }))
  ),

  fetchClaimsError: compose.action((state, error: any) =>
    state.set('claimApiStatus', RequestStatus({ status: 'error', error }))
  )
}));

export const {
  actions: claimsActions,
  actionCreators: claimsActionCreators,
  reducer: claimsReducer,
  selector: claimsSelector
} = claimsState;
